import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { LocalStorageService } from "ng2-webstorage";



@Component({
  selector: 'selectdashboardstudentH',
  templateUrl: 'selectdashboardstudentH.component.html',
  styleUrls: ['selectdashboardstudentH.component.scss'],

})
export class SelectdashboardstudentHComponent implements OnInit { 
  constructor(private router: Router, private localStorage: LocalStorageService) { }
  

  display = "none";
  public parent_email: string = "";

 
  ngOnInit() {
    // this.getSubjects();
    this.parent_email = this.localStorage.retrieve("ParentEmailOrPhone");
      console.log("parent_email", this.parent_email);
  
    
  }
 
  onButtonClick1() {
    this.router.navigate(['parent/1221/school-Q-registration']);
  }
  onButtonClick2() {
    this.router.navigate(['parent/1221/school-Q-promotion']);
  }
  onButtonClick3() {
    this.router.navigate(['parent/1221/view']);
  }
  /*
  onButtonClick4() {
    this.router.navigate(['parent/1221/add-grade-to-level']);
  }
  onButtonClick5() {
    this.router.navigate(['parent/1221/subject']);
  }
  onButtonClick6() {
    this.router.navigate(['parent/1221/sub-subject']);
  }
  onButtonClick7() {
    this.router.navigate(['parent/1221/add-exam']);
  }
  onButtonClick8() {
    this.router.navigate(['parent/1221/view-course']);
  }
  onButtonClick9() {
    this.router.navigate(['parent/1221/semester']);
  }
  onButtonClick10() {
    this.router.navigate(['parent/1221/add-subject']);
  }
  onButtonClick11() {
    this.router.navigate(['parent/1221/add-submodule']);
  }
  onButtonClick12() {
    this.router.navigate(['parent/1221/add-teacher-sub']);
  }
  onButtonClick13() {
    this.router.navigate(['parent/1221/add-batch']);
  }*/
  
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/Selectdashboardstudent/selectdashboardstudentH.ts